<template>
  <div class="mt-4 rounded-md bg-gray-50 p-3">
    <component
      :is="jobComponent"
      v-if="jobComponent"
      :job-data="jobData"
      :result-data="resultData"
    />
    <div v-else class="text-sm text-gray-600">
      <pre class="whitespace-pre-wrap">{{ JSON.stringify(jobData, null, 2) }}</pre>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ManageUserJobData from './ManageUserJobData.vue';

const props = defineProps<{
  jobName: string;
  jobData: Record<string, any>;
  resultData?: Record<string, any>;
}>();

const jobComponent = computed(() => {
  switch (props.jobName) {
    case 'manage_user':
      return ManageUserJobData;
    default:
      return null;
  }
});
</script>
